import { Box, Stack, Text } from '@chakra-ui/react'

interface SectionTitleProps {
  title: string
}

export const SectionTitle = ({ title }: SectionTitleProps) => {
  return (
    <Stack>
      <Stack direction="row" alignItems="center">
        <Text color="txtDarkGray">TWELVE X TWELVE</Text>
        <Box bgColor="txtDarkGray" w="10px" h="10px" borderRadius="50%" />
        <Text color="txtDarkGray">ABOUT US</Text>
      </Stack>
      <Text color="txtWhite" fontSize="xl">
        {title.toUpperCase()}
      </Text>
    </Stack>
  )
}
